import DashboardRewardsV2 from './DashboardRewardsV2';

export default DashboardRewardsV2;
